const f = {
  color: {
    background: {
      body: "#ffffffff",
      overlay: "#405261ff",
      footer: "#f9fafaff"
    },
    heading: "#131b24ff",
    confirmationBody: "#314351ff",
    focus: {
      outer: "#47a3ffff",
      inner: "#7e8e9eff"
    }
  }
};
export {
  f as simpleModal
};
